import { render, staticRenderFns } from "./GekkoBillingSwitch.vue?vue&type=template&id=23d53c47&scoped=true&"
import script from "./GekkoBillingSwitch.vue?vue&type=script&lang=js&"
export * from "./GekkoBillingSwitch.vue?vue&type=script&lang=js&"
import style0 from "./GekkoBillingSwitch.vue?vue&type=style&index=0&id=23d53c47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d53c47",
  null
  
)

export default component.exports